<div mat-ripple>
    <sc-loading-spinner [isLoading]="requestRunning">
        <label for="picture-btn" title="{{'take picture' | translate:['tmc-yard.ui.transport.details.dialog.documents.take-picture',
        translationService.language, translationService.revision]}}"><i class="picture-icon fa-light fa-camera"></i></label>
        <input id="picture-btn" name="picture-btn" class="picture-input-field" type="file" accept="image/*"
            (change)="handlePictureEvent($event)" />
    </sc-loading-spinner>
</div>
